import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import { selectEventCompanyId } from "modules/event/selectors";
import { useSelector } from "react-redux";
import companyApi from "modules/company/company.api";
import { getCompanySettingsByEventCode } from "services/apiService/apis";
import { Errors, trackError } from "modules/monitoring";

export const useIsCheckDisabled = () => {
  const { event: eventCode } = useQueryParams();
  const companyId = useSelector(selectEventCompanyId);

  const fetchIsCheckDisabled = async () => {
    try {
      // in event context we will have this in our redux store
      if (companyId) {
        const {
          companySettings: { disableVPNCheck },
        } = await companyApi.getCompanyPublicSettings(companyId);

        return Boolean(disableVPNCheck);
      }

      // when /mic-cam-check page is loaded manually we only have event code in query params
      if (eventCode) {
        const { disableVPNCheck } = await getCompanySettingsByEventCode(
          eventCode as string,
        );

        return Boolean(disableVPNCheck);
      }
    } catch (error) {
      trackError(error, {
        label: Errors.FETCH_VPN_CHECK_DISABLED,
      });
    }

    return false;
  };

  return { fetchIsCheckDisabled };
};
